module.exports = __webpack_public_path__ + "static/media/IMG_0405.9f5cad4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage/IMG_0405.jpg
// module id = 219
// module chunks = 0